// extracted by mini-css-extract-plugin
module.exports = {"title":"_37AsP","subTitle":"_32-ew","content":"_37yPE","back":"G0iDQ"};